const Decimal = require('decimal.js-light');

const add = (total, n) => (Number(n) ? total.plus(n) : total);

module.exports = (numbers) => Number(numbers.reduce(add, new Decimal(0)));
